import React from 'react'

const PaginaPerguntasFrequentes = () => {
  return (
    <div>
      
    </div>
  )
}

export default PaginaPerguntasFrequentes
